import { FC } from 'react';

/** The reasons a preview is unavailable, as tooltip content. */
export const UnavailableReasons: FC<{ reasons: string[] }> = (props) => {
  const { reasons } = props;

  if (reasons.length === 1) {
    return reasons[0];
  }

  return (
    <ul className="list-disc pl-4">
      {reasons.map((reason) => (
        <li key={reason}>{reason}</li>
      ))}
    </ul>
  );
};

export default UnavailableReasons;
